module.exports = __webpack_public_path__ + "static/media/UMinn.736031f0.png";